import { HOME_PAGE } from '@/app/constants';
import { getLoginUrl } from '@/app/utils';
import { safeStorage } from '@/app/utils/client';

/**
 * 需要登录验证的路径配置
 */
export const AUTH_REQUIRED_PATHS = [
  '/notification',
  '/profile',
  '/project',
  '/assets',
  '/claw',
  '/team-profile',
] as const;
const AUTH_OPTIONAL_PATHS = ['/claw/share-session', '/claw/file'] as const;

const AUTH_REQUIRED_LOGOUT_REDIRECT_KEY = 'auth-required-logout-redirect';

const getInternalPathname = (path: string): string | null => {
  if (!path.startsWith('/')) {
    return null;
  }

  return path.split(/[?#]/, 1)[0];
};

/**
 * 检查指定路径是否需要登录验证
 * @param path - 要检查的路径
 * @returns 是否需要登录
 */
export const isAuthRequired = (path: string): boolean => {
  const pathname = getInternalPathname(path);
  if (!pathname) {
    return false;
  }

  if (AUTH_OPTIONAL_PATHS.some((authPath) => pathname === authPath || pathname.startsWith(`${authPath}/`))) {
    return false;
  }

  return AUTH_REQUIRED_PATHS.some((authPath) => pathname === authPath || pathname.startsWith(`${authPath}/`));
};

export const markAuthRequiredLogoutRedirect = (): void => {
  safeStorage.setItem(AUTH_REQUIRED_LOGOUT_REDIRECT_KEY, '1');
};

const consumeAuthRequiredLogoutRedirect = (): boolean => {
  const shouldRedirectHome = safeStorage.getItem(AUTH_REQUIRED_LOGOUT_REDIRECT_KEY) === '1';
  if (shouldRedirectHome) {
    safeStorage.removeItem(AUTH_REQUIRED_LOGOUT_REDIRECT_KEY);
  }
  return shouldRedirectHome;
};

export const getAuthRequiredUnauthedRedirect = (redirectPath: string): string => {
  return consumeAuthRequiredLogoutRedirect() ? HOME_PAGE : getLoginUrl(redirectPath);
};
